import { render, staticRenderFns } from "./AccountRankingList.vue?vue&type=template&id=2b994120&scoped=true"
import script from "./AccountRankingList.vue?vue&type=script&lang=js"
export * from "./AccountRankingList.vue?vue&type=script&lang=js"
import style0 from "./AccountRankingList.vue?vue&type=style&index=0&id=2b994120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b994120",
  null
  
)

export default component.exports